import { action } from "typesafe-actions";
import { FspConfig } from "types";

export const FSP_CONFIG = "FSP_CONFIG";
export const setFspConfig = (payload: FspConfig) => action(FSP_CONFIG, payload);
